<template>
  <div class="copyright-header">
    <!-- :style="{ 'background-image': 'url(' + bg + ')' }" -->
    <div class="content headers" style="width: 1296px">
      <div class="flex" @click="link('/')">
        <!-- <div v-if="this.college_logo">
        <img
          style="width: 50px; height: 50px;border-radius: 50%;"
          :src="this.college_logo"
          alt=""
        />
      </div> -->
        <div
          class="title flex"
          :class="type == 'blue' ? 'blue' : ''"
          v-if="college_name"
        >
          {{ college_name }}
        </div>
        <div class="title flex" :class="type == 'blue' ? 'blue' : ''" v-else>
          <!-- 湖北版权登记服务平台 -->
          <img :src="logo" alt="" class="bqv2-header-title-logo pointer" />
        </div>
      </div>

      <div class="right" v-if="type == 'blue'">
        <div
          class="link links blue"
          @click="link('/')"
          style="margin-left: 0px"
        >
          首页
        </div>
        <div
          class="link blue"
          :class="activeName == 'copyright' ? 'activeName' : ''"
          @click="link('copyright')"
        >
          版权登记
        </div>
        <div
          class="link blue"
          :class="activeName == 'announcement' ? 'activeName' : ''"
          @click="link('/announcement')"
        >
          登记公告
        </div>
        <div class="link blue stawers" @click="jianse()">华文链浏览器</div>
        <div
          class="link blue"
          :class="activeName == 'rules' ? 'activeName' : ''"
          @click="goRules()"
        >
          政策法规
        </div>
        <div
          class="link blue"
          :class="activeName == 'finance' ? 'activeName' : ''"
          @click="finance()"
        >
          版权金融
        </div>
        <div
          class="link blue"
          :class="activeName == 'help_center' ? 'activeName' : ''"
          @click="star()"
        >
          帮助中心
        </div>
        <div class="user blue" v-if="usetInfo">
          <!-- <img
          class="header_img"
          @click="link('home')"
          :src="header_blue"
          alt=""
        /> -->

          <i
            class="el-icon-user header_img"
            style="height: 20px; width: 20px; font-size: 24px"
            :class="activeName == 'home' ? 'activeIco' : ''"
            @click="link('home')"
          ></i>

          <span
            @click="link('home')"
            class="stares"
            :class="activeName == 'home' ? 'activeName2' : ''"
            >个人中心</span
          >
          <span @click="link('login')">退出登录</span>
        </div>
        <div class="user blue" v-else>
          <span @click="link('login')">登录</span> |
          <span @click="link('register')">注册</span>
        </div>
        <!-- <div class='user'><img class='header_img' :src="header_w" alt=""> 退出登录</div> -->
      </div>
      <div class="right" v-if="is_register">
        <div class="user register">
          已有账号？<span class="color" @click="link('login')">请登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header_w from "@/assets/header/header_w.png";
import header_blue from "@/assets//header/header_blue.png";
import logo from "@/assets/V2/logo-V2.png";
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      header_w,
      header_blue,
      usetInfo: window.localStorage.getItem("userInfo"),
      usinfo: "",
      college_logo: "",
      imgUrl: this.$imgUrl,
      collegeCode: "",
      college_name: "",
      bg: "",
      activeName: "",
      logo: logo,
    };
  },
  props: {
    type: String,
    header: String,
    is_register: Boolean,
  },
  created() {
    if (this.$route.path != "") {
      this.activeName = this.$route.path.substring(1, this.$route.path.length);
    }
    console.log(this.activeName);
    this.bg =
      this.$baseUrl + window.localStorage.getItem("V2-bg").split("|")[0];
  },

  mounted() {
    var query = this.$route.query;
    // console.log(query)
    if (sessionStorage.getItem("collegeCode")) {
      this.collegeCode = sessionStorage.getItem("collegeCode");
    }
    if (query.code) {
      console.log(query.code);
      this.collegeCode = query.code;
      sessionStorage.setItem("collegeCode", query.code);
    }
    this.usinfo = JSON.parse(localStorage.getItem("userInfo"));
    // console.log(this.usinfo, "aaaaaaaaaaaa");
    this.a();
    if (sessionStorage.getItem("college_logo")) {
      this.college_logo = sessionStorage.getItem("college_logo");
    }
    if (sessionStorage.getItem("college_name")) {
      this.college_name = sessionStorage.getItem("college_name");
    }
  },
  methods: {
    goRules() {
      window.localStorage.setItem("cur", 5);
      this.$router.push("/rules");
    },
    jianse() {
      window.open(
        `http://61.183.153.141:4700/`
      );
      return;
      // 华文链浏览器
      let appId = "bqtmjqzh";
      let appSecret = "3173ada5899c4bbf96bc4e275f5e2a3c";

      //  window.localStorage.setItem("secretKeyToken", JSON.stringify({
      //                 accessToken:'13fdc3e22c054fb097c4f38700c6e00e',
      //                 timeStamp: moment().format("YYYY-MM-DD"),
      //               }));

      this.$getHttp("/pc/tShow/getToken").then((data) => {
        var accessToken = data.token;
        var timeStamp = new Date().getTime();
        window.open(
          `https://www.midu.com/midubqt/gateway/api/login/ssoLogin?timeStamp=${timeStamp}&systemId=${appId}&clientUserName=${appId}&channel=1&accessToken=${accessToken}`
        );
      });

      return;
      // 废弃
      if (
        window.localStorage.getItem("secretKeyToken") &&
        JSON.parse(window.localStorage.getItem("secretKeyToken")).timeStamp ==
          moment().format("YYYY-MM-DD")
      ) {
        // 缓存了
        var accessToken = JSON.parse(
          window.localStorage.getItem("secretKeyToken")
        ).accessToken;
        var timeStamp = new Date().getTime();
        window.open(
          `https://www.midu.com/midubqt/gateway/api/login/ssoLogin?timeStamp=${timeStamp}&systemId=${appId}&clientUserName=${appId}&channel=1&accessToken=${accessToken}`
        );
      } else {
        // 没缓存或过期
        this.$getHttp2("/oauth2/authorize", {
          appId,
          responseType: "code",
        }).then((data) => {
          var data1 = data.data;
          if (data1.code == "0000") {
            // 拿到授权码
            console.log("获取授权码success");

            var authorizeCode = data1.authorizeCode.authorizeCode;
            this.$getHttp2("/oauth2/token", {
              appId,
              appSecret,
              grantType: "authorization_code",
              authorizeCode: authorizeCode,
            }).then((data) => {
              var data2 = data.data;
              if (data2.code == "0000") {
                // 拿到token
                console.log("拿到token", data2);
                var accessToken = data2.accessToken.accessToken;
                window.localStorage.setItem(
                  "secretKeyToken",
                  JSON.stringify({
                    accessToken,
                    timeStamp: moment().format("YYYY-MM-DD"),
                  })
                );
                // console.log(window.localStorage.getItem("secretKeyToken"));
                var timeStamp = new Date().getTime();
                window.open(
                  `https://www.midu.com/midubqt/gateway/api/login/ssoLogin?timeStamp=${timeStamp}&systemId=${appId}&clientUserName=${appId}&channel=1&accessToken=${accessToken}`
                );
              }
            });
          } else {
            // 十分钟有效期
            console.log("获取授权码error");
          }
        });
      }

      // console.log(this.$getHttp2);
      return;
      window.open("https://bq.terpsiphone.com/");
    },
    star() {
      this.$router.push({
        path: "/help_center",
        query: { id: 1 },
      });
    },
    finance() {
      this.$router.push({
        path: "/finance",
        query: { id: 1 },
      });
    },
    a() {
      if (this.collegeCode) {
        // console.log("aaa");
        this.$getHttp("/pc/userLogin/findCollege", {
          collegeCode: this.collegeCode, //验证码
        }).then((res) => {
          // console.log(res.r[0], "^^^^^^^^^^^^^^^^^^^^^^^");
          if (res.r.length > 0) {
            this.college_logo = this.imgUrl + res.r[0].college_logo;
            this.college_name = res.r[0].college_name;
            sessionStorage.setItem("college_logo", res.r[0].college_logo);
            sessionStorage.setItem("college_name", res.r[0].college_name);
          }
        });
      } else if (this.usinfo.collegeId) {
        // console.log("aaa");
        this.$getHttp("/pc/userLogin/findCollege", {
          collegeId: this.usinfo.collegeId, //验证码
        }).then((res) => {
          // console.log(res.r[0], "^^^^^^^^^^^^^^^^^^^^^^^");
          if (res.r.length > 0) {
            this.college_logo = this.imgUrl + res.r[0].college_logo;
            this.college_name = res.r[0].college_name;
            sessionStorage.setItem("college_logo", res.r[0].college_logo);
            sessionStorage.setItem("college_name", res.r[0].college_name);
          }
        });
      }
    },
    link(name) {
      console.log(name, "234444");
      if (
        name != "/" &&
        name != "register" &&
        name != "/announcement" &&
        name != "/help" &&
        name != "login"
      ) {
        if (this.usinfo) {
          if (name == "/") {
            window.localStorage.setItem("cur", 0);
          }
          this.$router.push(name);
          sessionStorage.removeItem("form");
          // sessionStorage.removeItem('userInfo')
          // sessionStorage.removeItem('collegeCode')
        } else {
          // this.$message({
          //   type: "error",
          //   message: "请先前往登录",
          // });
          this.$router.push("login");
        }
      } else {
        window.localStorage.removeItem("form");
        // sessionStorage.removeItem('userInfo')
        // sessionStorage.removeItem('collegeCode')
        if (name == "/") {
          window.localStorage.setItem("cur", 0);
        }
        this.$router.push(name);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  // min-width: 1290px;
}
.bqv2-header-title-logo {
  vertical-align: middle;
  margin-left: 0px;
  width: 427px;
  height: auto;
}
.activeIco {
  position: relative;
  color: #e60012 !important;
  font-weight: 600 !important;
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 59px;
    background-color: #e60012;

    width: 150%;
    height: 2px;
  }
}
.activeName {
  position: relative;
  color: #e60012 !important;
  font-weight: 600 !important;
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 56px;
    background-color: #e60012;

    width: 100%;
    height: 2px;
  }
}
.activeName2 {
  position: relative;
  color: #e60012 !important;
  font-weight: 600 !important;
  &::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 55px;
    background-color: #e60012;

    width: 100%;
    height: 2px;
  }
}
.copyright-header {
  width: 100%;
  height: 90px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: contain;
  // background-color: rgba(255, 255, 255, 0.18);
  // background-color: rgba(69, 63, 63, 0.88);
  background-color: #fff;
  filter: blur(0.3px);
}
.stares {
  margin-right: 1rem;
}

.headers {
  height: 90px;
  line-height: 100px;
  // background: #F2F2F2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    font-size: 25px;
    font-weight: normal;
    font-stretch: normal;
    // color:  #0068b7;
    cursor: pointer;
    align-items: center;
    padding-left: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .header_img {
    width: 40px;
    height: 40px;
    vertical-align: baseline;
    line-height: 28px;
    // margin-right: 20px;
  }
  .link {
    margin-left: 18px;
    height: 27px;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 27px;
    letter-spacing: 0px;
    color: #333;
    cursor: pointer;
  }
  .links {
    margin-left: 110px;
  }
  .right {
    display: flex;
    align-items: center;
  }
}
.blue {
  color: #333;
}
.user {
  margin-left: 30px;
  font-size: 18px;
  cursor: pointer;
}
.color {
  color: #0068b7;
}
.register {
  color: #333333;
}
.content {
  //  background: #fff;
}
@media screen and (max-width: 1024px) {
  * {
    font-size: 12px;
  }
  .content {
    // width: 100%;
    height: 3.75rem;
    background: #0068b7;
    background: #ffffff;
  }
  .content {
    .flex {
      display: none;
    }
    .right {
      width: 100%;
      position: relative;
    }
  }
  .headers .links {
    margin-left: 0px;
  }
  .headers .link {
    margin-left: 3%;
    font-size: 0.8rem;
    // width: 100%;
    text-align: center;
  }

  .user {
    margin-left: 0px;
    position: absolute;
    right: 2%;
    margin-top: 2px;
    font-size: 0.8rem;
    span {
      font-size: 0.8rem;
    }
    img {
      display: none;
    }
  }
  .content-son {
    width: 100%;
  }
  .content-son .content-arr-box {
    width: 100%;
  }
  .arr-item2 {
    flex: 1;
  }
  .frame-box {
    width: 3.27rem;
  }
  .nav {
    font-size: 1rem;
  }
  .tail {
    padding: 1.25rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue